import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const ZoomLoginMessage = ({ disableZoomLoginMessage }) => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        bgcolor: "white",
        p: 4
      }}
    >
      <Stack
        sx={{
          width: "100%"
        }}
      >
        <Typography sx={{ fontWeight: "600", color: "#1C2024" }}>
          Success! Your Zoom account is now connected.
        </Typography>
        <Typography sx={{ opacity: 0.7, color: "#595959" }}>
          Now you can manage recordings and access transcripts right here!
        </Typography>
        <Stack
          sx={{
            my: 1,
            pt: 2,
            px: 1,
            bgcolor: "#FFF8E1",
            borderRadius: 2
          }}
        >
          <Stack direction="row" alignContent="center">
            <WarningAmberIcon sx={{ color: "#FFAB00", mr: 1 }} />
            <Typography sx={{ color: "#6D4C41" }}>
              To record, import and transcribe your meetings:
            </Typography>
          </Stack>
          <Box sx={{ color: "#6D4C41" }}>
            <ul>
              <li>You must be the meeting organizer.</li>
              <li>Click the &apos;Record&apos; button in Zoom when the meeting starts</li>
            </ul>
          </Box>
        </Stack>
        <Typography sx={{ fontWeight: "500", color: "#1C2024" }}>
          Enable Recording Import:
        </Typography>
        <Typography sx={{ opacity: 0.7, color: "#595959" }}>
          To import recordings automatically, enable the toggle for selected
          meetings.
        </Typography>
      </Stack>
      <Stack
        direction="row"
        alignItems="flex-end"
        justifyContent={"flex-end"}
        spacing={2}
        sx={{
          width: "100%",
          pt: 2 // Padding top
        }}
      >
        <Button
          onClick={disableZoomLoginMessage}
          variant="contained"
          sx={{ bgcolor: "#0880EA", color: "white", fontSize: 12 }}
        >
          Got it
        </Button>
      </Stack>
    </Box>
  );
};

export default ZoomLoginMessage;
